<template>
  <InputRadioGroup
    v-if="!familyStore.ui.showFamilyAddedPdp"
    legend="Välj surfmängd"
    :extra-legend="planText"
    type-class="product-page"
  >
    <InputRadioButton
      v-for="plan in productPageStore.availablePlans"
      :id="`plan-${plan?.PlanId.toString()}-${plan?.PlanTypeId.toString()}`"
      :key="`${plan?.PlanId}${plan?.PlanTypeId}`"
      v-model="productPageStore.productState.selectedPlanId"
      :value="plan?.PlanId.toString()"
      :group-name="`plans-${groupNameId}`"
      @update:model-value="productPageStore.changeOption('plans')"
    >
      <template #simple-label-replacement>
        <p
          class="heading-xs flex items-center"
          :aria-label="
            !!plan?.RegularDataAllowance
              ? `Ordinarie ${plan?.RegularDataAllowance} GB surf, nu ${plan?.DataAllowance} GB surf`
              : `${plan?.DataAllowance} GB surf`
          "
        >
          <span
            v-if="plan?.RegularDataAllowance"
            class="strike-through text-text-secondary me-8"
            aria-hidden="true"
          >
            {{ plan?.RegularDataAllowance }}
          </span>
          {{ plan?.DataAllowance }} GB
        </p>
      </template>
    </InputRadioButton>
  </InputRadioGroup>

  <PdpSubscriptionPlanFacts />
  <InputCheckbox
    v-if="!familyStore.ui.showFamilyAddedPdp"
    v-model="isStudent"
    label="Jag är student!"
  />
  <div v-if="totalCost" class="flex flex-row gap-8 items-center">
    <nuxt-icon
      class="text-24 text-text-primary"
      name="coin"
      aria-hidden="true"
    />
    <p class="heading-xxs">
      Totalt pris under delbetalningstiden
      {{ productPageStore.totalCostOverBindingPeriodToDisplay }}
      kr
    </p>
  </div>
</template>

<script lang="ts" setup>
import type { AggregatedBundlePriceDto } from '~/models/ListingProduct.api.model';
const familyStore = useFamilyStore();
const productPageStore = useMyProductPageStore();
const isStudent: Ref<boolean> = ref(
  productPageStore.productState.isStudentSelected,
);

const groupNameId = useId();

watch(isStudent, (value: boolean, oldValue: boolean) => {
  if (value !== oldValue) {
    productPageStore.changeIsStudent(value);
  }
});

const planText = computed(() => {
  if (
    productPageStore.currentBundlePrice?.Plan?.RegularMonthlyFee &&
    productPageStore.currentBundlePrice?.Plan?.OfferValidityInMonthsDiscount
  ) {
    return `${productPageStore.currentBundlePrice?.Plan?.MonthlyFee.toLocaleString(
      'sv-SE',
    )} kr/mån i
    ${
      productPageStore.currentBundlePrice?.Plan?.OfferValidityInMonthsDiscount +
      ' mån därefter ' +
      productPageStore.currentBundlePrice?.Plan?.RegularMonthlyFee +
      ' kr/mån'
    }`;
  }

  return `${productPageStore.currentBundlePrice?.Plan?.MonthlyFee.toLocaleString(
    'sv-SE',
  )} kr/mån ${productPageStore.selectedBindingPeriod === 0 ? '' : 'i ' + productPageStore.selectedBindingPeriod + ' mån'}`;
});

const totalCost = computed(() =>
  (
    productPageStore.currentBundlePrice as AggregatedBundlePriceDto | undefined
  )?.TotalCost.toLocaleString('sv-SE'),
);
</script>

<style lang="scss" scoped></style>
